import { render, staticRenderFns } from "./UserControls.vue?vue&type=template&id=6acf4890&"
import script from "./UserControls.vue?vue&type=script&lang=ts&"
export * from "./UserControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports